import { Optional, Self, Input, Directive } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { Subject } from 'rxjs';

@Directive()
export class BaseControlValueAccessor<T> implements ControlValueAccessor {
  onChange!: (value: string) => void; // fv
  onTouch!: (value: string) => void; // fv
  private _placeholder!: string;
  private _value!: string; // fv
  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl !== null) {
      this.ngControl.valueAccessor = this;
    }
  }

  stateChanges = new Subject<void>();
  // constructor() {}
  /**
   * @param obj
   */
  writeValue(obj: string): void {
    // fv
    this.value = obj;
  }
  /**
   * @param fn
   */
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  /**
   * @param fn
   */
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  /**
   *
   */
  @Input()
  set value(value: string) {
    // fv
    this._value = value;
    this.stateChanges.next();
  }

  /**
   *
   */
  get value() {
    return this._value;
  }

  /**
   *
   */
  @Input()
  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }

  /**
   *
   */
  get placeholder() {
    return this._placeholder;
  }

  public get showError(): boolean | null {
    return this.ngControl?.invalid && this.ngControl.dirty;
  }
}
